<template>
  <div :id="normalisedId" :data-track-type="track.kind" :class="`${track.kind}-wrapper`">
    <transition name="fade" appear v-if="track.kind !== 'audio'">
      <video v-if="renderVideo" :class="{'flipped': flip}" :ref="'trackEl'" :data-user-tag="`${track.kind}-${userId}`"></video>
      <div class="video-missing-avatar" v-else>
        <profile-pic :avatar="avatar" :styles="{'backgroundColor': colour}" />
      </div>
    </transition>
    <audio :ref="'trackEl'" v-if="renderAudio" :data-user-tag="`${track.kind}-${userId}`"></audio>
  </div>
</template>

<script>
  /**
  * Audio / Video track component for twilio media track object
  */
  import { Track } from 'twilio-video'
  import { normaliseFirefoxTrackId } from '@/../../shared/src/utils'
  import ProfilePic from '@/../../shared/src/components/common/ProfilePic.vue'

  export default {
    name: 'TwilioVideoTrack',

    components: {
      'profile-pic': ProfilePic
    },

    props: {
      track: {
        'type': Track,
        'default': null
      },
      trackDetached: {
        'type': Boolean,
        'default': false
      },
      stopOnDestroy: {
        'type': Boolean,
        'default': true
      },
      flip: {
        'type': Boolean,
        'default': false
      },
      renderTrack: {
        'type': Boolean,
        'default': false
      },
      userId: {
        'type': String,
        'default': ''
      },
      audioOutputId: {
        'type': String,
        'default': null
      },
      avatar: {
        'type': String,
        'default': null
      },
      colour: {
        'type': String,
        'default': null
      }

    },

    computed: {
      normalisedId () {
        return `_${normaliseFirefoxTrackId(this.track.name)}`
      },

      renderVideo () {
        if (this.track.kind === 'video') {
          // if (this.track instanceof LocalVideoTrack) {
          //   return !this.trackDetached
          // } else {
            return !this.trackDetached && this.renderTrack
          // }
        }
        return false
      },

      renderAudio () {
        return this.track.kind === 'audio'
      }
    },

    methods: {
      trackAttach () {
        if (this.track && this.track.attach) {
          this.track.attach(this.$refs.trackEl)
          if (this.audioOutputId && this.$refs.trackEl.setSinkId) {
            this.$refs.trackEl.setSinkId(this.audioOutputId)
          }
        }
      },

      trackDetach () {
        if (this.track && this.track.stop && this.stopOnDestroy) {
          this.track.stop()
        }
        if (this.track && this.track.disable && this.stopOnDestroy) {
          this.track.disable()
        }
        if (this.track && this.track.detach) {
          this.track.detach(this.$refs.trackEl)
        }
        if (this.$refs.trackEl && this.$refs.trackEl.srcObject) {
          this.$refs.trackEl.srcObject = null
        }
      }
    },

    mounted () {
      this.trackAttach()
    },

    updated () {
      this.trackAttach()
    },

    beforeDestroy () {
      this.trackDetach()
    }
  }
</script>

<style scoped lang="less">

  video, .video-missing-avatar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border-radius: 4px;

    &.flipped {
      transform: rotateY(180deg);
    }

    img, svg {
      height: 70%;
      width: 52%;
      margin-top: 10%;
      &.img-svg {
        /*filter: invert(42%) sepia(93%) saturate(1352%) hue-rotate(87deg) brightness(119%) contrast(119%);*/
      }

    }


  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .75s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>

<docs></docs>

